// Đường thoát cho người không biết giờ sinh, đặt ngay cạnh ô chọn giờ ở mọi nơi
// bắt nhập giờ (Tử Vi, Bát Tự, Bói Đê tổng hợp, Chỉ tay).
//
// Một component dùng chung chứ không copy từng trang: câu chữ và đích đến phải
// giống nhau ở cả bốn chỗ, và trước đây mỗi trang một dòng link riêng nên đã lệch.
//
// KHÔNG lồng cái này vào trong <label> của ô giờ: bấm vào label sẽ kích hoạt ô
// giờ chứ không mở link, và <a> nằm trong <label> là markup không hợp lệ.
import { Link } from "@tanstack/react-router";
import { ArrowRight, Sparkles } from "lucide-react";

import { cn } from "@/lib/utils";

export function UnknownHourCta({ className }: { className?: string }) {
  return (
    <Link
      to="/doan-gio-sinh"
      className={cn(
        "group flex items-center gap-2.5 rounded-xl border border-dashed border-gold-soft/60 bg-primary/[0.06] px-3 py-2.5 transition hover:border-primary/70 hover:bg-primary/10",
        className,
      )}
    >
      <span className="grid size-7 shrink-0 place-items-center rounded-full bg-primary/12 text-primary">
        <Sparkles className="size-3.5" />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-xs font-semibold leading-snug text-foreground">
          Bạn không biết giờ sinh của mình?
        </span>
        <span className="block text-[11px] leading-snug text-primary">
          Hãy để Bói Đê đoán giờ sinh của bạn
        </span>
      </span>
      <ArrowRight className="size-4 shrink-0 text-primary transition group-hover:translate-x-0.5" />
    </Link>
  );
}
